<template lang="pug">
    v-text-field(
        v-bind="$attrs"
        v-model="_value"
        :rules="_rules"
        ref="rut"
        @keydown="handleKeydown"
    )
</template>

<script>
import { head, cloneDeep, reverse } from 'lodash'
import RUTUtils from '@/mixins/RUTUtils'
import { numberFormatter } from './numberUtils'
export default {
    name: 'rut-input',
    data: function() {
        return {
            rut: '',
        }
    },
    props: {
        value: {
            type: String,
            default: '',
        },
        rules: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        /**
         * @description
         */
        _value: {
            get: function() {
                return this.format(this.value)
            },
            set: function(val) {
                this.$emit('input', this.unFormat(val))
                this.$emit('valid', this.$refs.rut.validate())
            },
        },
        _rules() {
            return this.rules.concat(this.mixRUTRules.validFormattedRUT)
        },
    },
    methods: {
        format(val) {
            if (!val || val.length === 1) return val
            let aux = []
            if (val.includes('-')) val = val.split('-').join('')
            let v = cloneDeep(val)
            let dv = head(reverse(v.split('')))
            let body = v.substring(0, v.length - 1)
            body = numberFormatter(body)
            let rut = body + '-' + dv
            return rut
        },
        unFormat(val) {
            if (val.length === 2 && !val.includes('-'))
                return val.split('').join('-')
            if (!val || !val.includes('-')) return val
            if (val.length === 2) return val.split('-').join('')
            let v = cloneDeep(val)
            v = v
                .split('-')
                .join('')
                .split('.')
                .join('')
            let dv = head(reverse(v.split('')))
            let body = v.substring(0, v.length - 1)
            return `${body}-${dv}`
        },
        handleKeydown(e) {
            function stop() {
                e.preventDefault()
                e.stopPropagation()
            }
            if (e.ctrlKey && e.key === 'v') {
                return
            }
            if (e.key.length === 1 && this.value.length === 10) {
                stop()
                return
            }
            if (e.key.length === 1 && this.value.includes('k')) {
                stop()
                return
            }
            if (e.key.length === 1 && (isNaN(e.key) && e.key !== 'k')) {
                stop()
                return
            }
        },
        focus() {
            this.$refs.rut.focus()
        },
    },
    mixins: [RUTUtils],
    updated: function() {
        this.rut = this.value
    },
}
</script>

<style lang="scss">
.formLabel {
    font-weight: bold;
    min-width: 150px;
    max-width: 150px;
    font-size: 20px;
}
</style>
